import Cookies from 'js-cookie'
var KEY = 'TokenKey'
export default {
  setUser (user) {
    // 把user对象存储到sessionStorage
    const jsonStr = JSON.stringify(user)
    var createtime = user.create_time + user.expires_in - 300000
    var expiresTime = new Date(createtime)
    if (user.expires_in) {
      return Cookies.set(KEY, jsonStr, {
        expires: expiresTime
      })
    } else {
      return Cookies.set(KEY, jsonStr)
    }
  },
  setIp (ip) {
    return localStorage.setItem('ip', ip)
  },
  getIp () {
    let ip = ''
    if (localStorage.getItem('ip')) {
      ip = localStorage.getItem('ip')
    } else {
      ip = ''
    }
    return ip
  },
  getUser () {
    let jsonStr = {}
    if (Cookies.get(KEY)) {
      jsonStr = JSON.parse(Cookies.get(KEY))
    } else {
      jsonStr = {}
    }
    return jsonStr
  },
  delUser () {
    // 删除 KEY 对应的数据
    Cookies.remove(KEY)
  }
}
